// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"ClassPortalPage_carouselItem__NiRPk","classPortalSlideIn":"ClassPortalPage_classPortalSlideIn__2qGK1"};